import { useEffect } from 'react'
import { InlineLoading } from '../inline-loading'
import { Mixed } from 'common-types'
import { ReactFormState, useFormState } from '@/lib/form-state/react-form-state'

type Props = {
    title: string
    description?: string
    loading?: boolean
    initialState?: Mixed
    fields: {
        required?: boolean
        name: string
        placeholder?: string
        mask?: string
        value?: string
        type?: string
        props?: Mixed
        items?: {
            title: string
            value: string
        }[]
    }[]
    onCancel: () => any
    onSubmit: (values: Mixed) => any
}

export const FormDialog: React.FC<Props> = props => {
    return (
        <dialog className="modal modal-open">
            {props.loading && (
                <div className="modal-box !w-full !max-w-md !mx-4 !p-0">
                    <InlineLoading />
                </div>
            )}
            {!props.loading && <Content {...props} />}
        </dialog>
    )
}

const Content: React.FC<Props> = ({
    title,
    description = '',
    onCancel,
    onSubmit,
    fields,
    initialState,
}) => {
    const { formRef, submitButtonRef } = useFormState('form-dialog')

    useEffect(() => {
        const state = ReactFormState.getInstance('form-dialog')

        state.on(
            'ready',
            'form-data',
            initial => {
                if (initial) {
                    state.setInitialState(initial)
                }
            },
            [initialState]
        )
    }, [])

    return (
        <div className="p-7 modal-box form-items" ref={formRef}>
            <div className="font-medium-xx">{title}</div>
            {description && (
                <div className="text-desc text-sm mt-3">{description}</div>
            )}

            <div className="my-7 flex flex-col gap-3 ">
                {fields.map((field, index) => {
                    if (field.type == 'select' && field.items) {
                        return (
                            <select
                                className="select select-bordered"
                                name={field.name}
                                required={
                                    field.required !== undefined
                                        ? field.required
                                        : false
                                }
                            >
                                {field.items.map((item, i) => {
                                    return (
                                        <option value={item.value}>
                                            {item.title}
                                        </option>
                                    )
                                })}
                            </select>
                        )
                    }

                    if (field.type == 'textarea') {
                        return (
                            <textarea
                                required={
                                    field.required !== undefined
                                        ? field.required
                                        : false
                                }
                                key={index}
                                {...field.props}
                                placeholder={field.placeholder ?? ''}
                                className="input input-bordered w-full !h-[400px]"
                                name={field.name}
                            ></textarea>
                        )
                    }

                    return (
                        <input
                            required={
                                field.required !== undefined
                                    ? field.required
                                    : false
                            }
                            key={index}
                            {...field.props}
                            placeholder={field.placeholder ?? ''}
                            type={field.type ?? 'text'}
                            className="input input-bordered w-full"
                            name={field.name}
                            data-mask={field.mask}
                        />
                    )
                })}
            </div>

            <div className="modal-action">
                <button className="btn btn-ghost" onClick={onCancel}>
                    Cancelar
                </button>
                <button
                    className="btn btn-secondary modal-form-submit-button"
                    ref={submitButtonRef}
                    onClick={() => {
                        const state = ReactFormState.getInstance('form-dialog')
                        onSubmit(state.values)
                    }}
                >
                    Salvar
                </button>
            </div>
        </div>
    )
}
